import React, { useEffect, useState } from 'react';
import Navbar from 'components/NavBar/Navbar';
import Cvheader from 'components/cvrepo/Cvheader';
import CardList from './CardList';
import Footer from 'components/Footer/Footer';
import './repo.css';

const Repo = () => {
    
    return ( 
        <div>
            <Navbar />
            <Cvheader />
            <div className="home">
                    <CardList/>
            </div>
            <Footer />
        </div>
     );
}
 
export default Repo;